const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the manager reports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerAssessments', ['Application', 'Authorization', 'Managers', 'Users', 'UserAssessments', '$translate', function (Application, Authorization, Managers, Users, UserAssessments, $translate) {
  return {
    restrict: 'E',
    scope: {
      tab: '=',
      manager: '=',
      managerConfiguration: '=?',
      singleUser: '=',
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-assessments.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.loading = true;
      self.user = Authorization.getAuthToken().user;
      self.features = Application.features.flags();
      if ($scope.managerConfiguration && $scope.managerConfiguration.hide_non_managing_groups) {
        self.hideNonManagingGroups = true;
      }

      self.userAssessmentModal = {
        activeUserAssessment: null,
        activeAssessment: null,
        onView: function(userAssessment) {
          self.userAssessmentModal.activeUserAssessment = userAssessment._id;
          self.userAssessmentModal.activeAssessment = userAssessment.assessment;
        }
      }

      self.selectUser = function(id) {
        $scope.singleUser = id;
        $scope.tab = 'user';
      };

      self.info = {
        userAssessments: [],
        loading: false,
        searching: false,
        sortName: 'createdAt',
        sortOrder: -1,
        query: {},
        onData: function(data) {
          self.info.userAssessments = data;
        },
        progress: function(item) {
          if (item.passed) {
            return 'green check';
          }
          if (item.awaiting_manual_grade) {
            return 'clock outline';
          }
          if (item.scores && !item.assessment.allow_retake) {
            return 'red close';
          }
          if (item.scores && item.assessment.allow_retake && item.scores.length >= item.assessment.number_of_retakes + 1) {
            return 'red close';
          }
          return 'load';
        },
      };

      self.navigation = {
        noNext: false,
        page: 1,
        pageCount: 10,
        previous: function () {
          if (self.navigation.page === 1) {
            return;
          }
          self.navigation.page--;
          self.load();
        },
        next: function () {
          if (self.info.userAssessments.length !== self.navigation.pageCount || self.navigation.noNext) {
            return;
          }
          self.navigation.page++;
          self.load();
        }
      };

      self.search = function(query) {
        self.info.query = query;
        self.info.page = 1;
        self.load();
      }

      self.initialize = function () {
        self.info.userAssessments = [];
        self.info.loading = false;
        self.info.searching = false;
        self.load();
      };

      self.load = function () {
        self.info.loading = true;
        Managers.assessments({ subresource: $scope.manager._id, page: self.navigation.page, perPage: self.navigation.pageCount, query: self.info.query }).$promise
        .then(function(userAssessments) {
          self.info.onData(userAssessments);
          self.info.loading = false;
        }).catch(function (error) {
          self.info.loading = false;
          console.log('Error getting user assessments:', error);
        });
      };

     self.initialize();
   
    }],
    controllerAs: 'managerAssessments'
  };
}]);